module.exports = __webpack_public_path__ + "img/Acmi_2.4006614c.gif";